import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import { TRIAL_EXPIRATION_TEXT } from 'common/constants';
import { onLogout } from 'common/utils/authCheck';

import styles from 'features/common/Common.module.scss';

const TrialExpirationModal = () => {
	const onOkClick = () => {
		onLogout();
	};

	return (
		<ModalEle open sxBoxProps={{ width: '30%', height: '100%' }}>
			<Box className={styles['trial-modal-layout']}>
				<Box>
					<Typography variant="h6" sx={{ mb: 2 }}>
						{TRIAL_EXPIRATION_TEXT}
					</Typography>
				</Box>
				<Box className={styles['trial-modal-button']}>
					<ButtonComp
						variant="contained"
						onClick={onOkClick}
						compClass={styles['trial-modal-button-styles']}
						btnType="primary"
						size="small"
					>
						OK
					</ButtonComp>
				</Box>
			</Box>
		</ModalEle>
	);
};

export default TrialExpirationModal;
